import { render, staticRenderFns } from "./tifDistrictsEditDialog.vue?vue&type=template&id=36731d23&scoped=true&"
import script from "./tifDistrictsEditDialog.vue?vue&type=script&lang=js&"
export * from "./tifDistrictsEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./tifDistrictsEditDialog.vue?vue&type=style&index=0&id=36731d23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36731d23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VContainer,VRow,VSelect,VSpacer,VTextField})
